import React from 'react';
import { FiCreditCard, FiAlertCircle } from 'react-icons/fi';
import { useMembership } from '../../contexts/MembershipContext';

const CreditCostNotification = ({ serviceCost, serviceName }) => {
  const { creditBalance } = useMembership();
  const hasEnoughCredits = creditBalance && creditBalance.credits >= serviceCost;
  
  return (
    <div className={`p-3 rounded-md mb-4 flex items-center ${hasEnoughCredits ? 'bg-blue-50' : 'bg-red-50'}`}>
      <div className="mr-3">
        {hasEnoughCredits ? (
          <FiCreditCard className={`h-5 w-5 text-blue-500`} />
        ) : (
          <FiAlertCircle className={`h-5 w-5 text-red-500`} />
        )}
      </div>
      <div>
        <p className={`text-sm ${hasEnoughCredits ? 'text-blue-700' : 'text-red-700'}`}>
          {hasEnoughCredits ? (
            <>This {serviceName} will cost <strong>{serviceCost} credits</strong>. You have {creditBalance.credits} credits available.</>
          ) : (
            <>This {serviceName} requires <strong>{serviceCost} credits</strong>, but you only have {creditBalance?.credits || 0} credits. Please upgrade your plan or purchase more credits.</>
          )}
        </p>
      </div>
    </div>
  );
};

export default CreditCostNotification;